import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledIconRootOptions } from './Icon.types';

export const StyledIcon = styled('span')<StyledIconRootOptions>(({ size = '2XS', theme }) => {
  return {
    width: theme.size[size],
    height: theme.size[size],
    minWidth: theme.size[size],
    minHeight: theme.size[size],
  };
}, getAllStyledProps);
